import { CSSProperties, forwardRef, HTMLAttributes, PropsWithChildren } from "react";
import { ResponsiveProp } from "@shared/constaints/ui";
import { useResponsiveProp } from "@shared/hooks";

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  fullWidth?: ResponsiveProp<boolean>;
  gap?: ResponsiveProp<number>;
  direction?: ResponsiveProp<CSSProperties['flexDirection']>;
  justifyContent?: ResponsiveProp<CSSProperties['justifyContent']>;
  alignItems?: ResponsiveProp<CSSProperties['alignItems']>;
  flexWrap?: ResponsiveProp<CSSProperties['flexWrap']>;
}

type StackType = PropsWithChildren<StackProps>;

export const Stack = forwardRef<HTMLDivElement, StackType>((props, ref) => {
  const {
    fullWidth = false,
    gap = 0,
    direction = 'column',
    justifyContent = 'start',
    alignItems = 'start',
    flexWrap,
    style,
    children,
    ...divProps
  } = props;

  const responsiveWidth = useResponsiveProp({ width: '100%' });

  const fullWidthStyle = fullWidth ? responsiveWidth : {};

  const stackStyle: CSSProperties = {
    ...fullWidthStyle,
    ...style,
    display: 'flex',
    flexDirection: useResponsiveProp(direction),
    justifyContent: useResponsiveProp(justifyContent),
    alignItems: useResponsiveProp(alignItems),
    flexWrap: useResponsiveProp(flexWrap),
    gap: useResponsiveProp(gap)
  }

  return (
    <div style={stackStyle} {...divProps} ref={ref}>
      {children}
    </div>
  );
});